<template>
    <v-container max-width="100%" style="margin-top: 2%">
        <v-toolbar style="
          margin-bottom: 10px;
          margin-left: 3px;
          margin-top: 10px;
          border-radius: 10px;
          padding-top: 60px;
          padding-bottom: 20px;
          height: 200px;
        ">
            <v-container>
                <v-form ref="form" v-model="formValidado">
                    <v-row>
                        <v-col cols="12" sm="4" md="5">
                            <v-autocomplete v-model="idEmpresaSelected" :items="empresas" item-text="razao_social"
                                item-value="id_empresa" clearable :label="$tc('company.self', 1)"
                                :rules="[(v) => !!v || $t('area.selectCompany')]"></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                            <v-datetime-picker :label="$t('speedReport.startDate')" v-model="dti"
                                :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                                date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                                <template slot="dateIcon">
                                    <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                    <v-icon>mdi-clock</v-icon>
                                </template>
                            </v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="4" md="3">
                            <v-datetime-picker :label="$t('speedReport.endDate')" v-model="dtf"
                                :time-picker-props="timeProps" :text-field-props="textFieldProps" time-format="HH:mm:ss"
                                date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                                <template slot="dateIcon">
                                    <v-icon>mdi-calendar</v-icon>
                                </template>
                                <template slot="timeIcon">
                                    <v-icon>mdi-clock</v-icon>
                                </template>
                            </v-datetime-picker>
                        </v-col>
                        <v-col cols="12" sm="6" md="1">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs"
                                        v-on="on" @click="populaRelatorio">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{ $t('operation.search') }}</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-toolbar>

        <v-card elevation="5" style="border-radius: 10px; margin-bottom: 10px;">
            <v-card-title color="primary">
                <div>{{ $t('relConciliation.aggregated') }}</div>
                <v-spacer></v-spacer>
                <vue-json-to-csv :json-data="[agregado]" csv-title="relconciliacaoagregado" separator=";" :labels="{
                    km_merus: { title: $t('relConciliation.fields.totalKmMerus') },
                    km_merus_nao_autorizado: { title: $t('relConciliation.fields.unauthorizedKmMerus') },
                    km_merus_autorizado: { title: $t('relConciliation.fields.authorizedKmMerus') },
                    km_operadora: { title: $t('relConciliation.fields.totalKmOperator') },
                    km_operadora_nao_autorizado: { title: $t('relConciliation.fields.unauthorizedKmOperator') },
                    km_operadora_autorizado: { title: $t('relConciliation.fields.authorizedKmOperator') },
                    diff_km_merus_operadora: { title: $t('relConciliation.fields.kmDifference') },
                    diff_km_merus_operadora_nao_autorizado: { title: $t('relConciliation.fields.unauthorizedKmDifference') },
                    diff_km_merus_operadora_autorizado: { title: $t('relConciliation.fields.authorizedKmDifference') },
                    n_viagens_merus: { title: $t('relConciliation.fields.validMerusTrips') },
                    n_viagens_invalidas: { title: $t('relConciliation.fields.invalidMerus') },
                    n_viagens_canceladas: { title: $t('relConciliation.fields.cancelled') },
                    n_viagens_nao_autorizadas_merus: { title: $t('relConciliation.fields.unauthorizedMerus') },
                    n_viagens_operadora: { title: $t('relConciliation.fields.validOperatorTrips') },
                    n_viagens_invalidas_operadora: { title: $t('relConciliation.fields.invalidOperator') },
                    n_viagens_nao_realizadas_operadora: { title: $t('relConciliation.fields.notRealized') },
                    n_viagens_nao_autorizadas_operadora: { title: $t('relConciliation.fields.unauthorizedOperator') },
                    n_viagens_validas_merus_operadora: { title: $t('relConciliation.fields.validMerusOperator') },
                    n_viagens_conciliadas: { title: $t('relConciliation.fields.conciliated') },
                    n_viagens_nao_conciliadas_merus: { title: $t('relConciliation.fields.notConciliatedMerus') },
                    n_viagens_nao_conciliadas_operadora: { title: $t('relConciliation.fields.notConciliatedOperator') },
                    dias_processados_merus: { title: $t('relConciliation.fields.processedDaysMerus') },
                    n_veiculos_merus: { title: $t('relConciliation.fields.merusVehicles') },
                    n_veiculos_merus_autorizados: { title: $t('relConciliation.fields.authorizedMerusVehicles') },
                    dias_processados_operadora: { title: $t('relConciliation.fields.processedDaysOperator') },
                    n_veiculos_operadora: { title: $t('relConciliation.fields.operatorVehicles') },
                    n_veiculos_operadora_autorizados: { title: $t('relConciliation.fields.authorizedOperatorVehicles') },
                }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" color="primary" small class="mb-2 mr-2" fab>
                                <v-icon>mdi-export-variant</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ $t('system.labels.exportToCsv') }}</span>
                    </v-tooltip>
                </vue-json-to-csv>
                <ExportTablePdf :content="[agregado]" :headers="headersAgregado" filename="relconciliacaoagregado"
                    :title="$t('relConciliation.aggregatedTitle')"
                    :subtitle="`${razaoSocial} | Data Referência: ${dataPdfInicial} - ${dataPdfFinal}`"
                    :horizontal-page-break="true"></ExportTablePdf>
            </v-card-title>
            <v-card-text>
                <v-container v-if="loadingAgregado">
                    <v-progress-linear indeterminate color="primary"></v-progress-linear>
                </v-container>
                <v-container v-else>
                    <v-row>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="Intl.NumberFormat('pt-BR').format(agregado.km_merus)"
                                :label="$t('relConciliation.fields.totalKmMerus')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="Intl.NumberFormat('pt-BR').format(agregado.km_merus_nao_autorizado)"
                                :label="$t('relConciliation.fields.unauthorizedKmMerus')" readonly
                                outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="Intl.NumberFormat('pt-BR').format(agregado.km_merus_autorizado)"
                                :label="$t('relConciliation.fields.authorizedKmMerus')" readonly
                                outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="Intl.NumberFormat('pt-BR').format(agregado.km_operadora)"
                                :label="$t('relConciliation.fields.totalKmOperator')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                :value="Intl.NumberFormat('pt-BR').format(agregado.km_operadora_nao_autorizado)"
                                :label="$t('relConciliation.fields.unauthorizedKmOperator')" readonly
                                outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="Intl.NumberFormat('pt-BR').format(agregado.km_operadora_autorizado)"
                                :label="$t('relConciliation.fields.authorizedKmOperator')" readonly
                                outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="Intl.NumberFormat('pt-BR').format(agregado.diff_km_merus_operadora)"
                                :label="$t('relConciliation.fields.kmDifference')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                :value="Intl.NumberFormat('pt-BR').format(agregado.diff_km_merus_operadora_nao_autorizado)"
                                :label="$t('relConciliation.fields.unauthorizedKmDifference')" readonly
                                outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field
                                :value="Intl.NumberFormat('pt-BR').format(agregado.diff_km_merus_operadora_autorizado)"
                                :label="$t('relConciliation.fields.authorizedKmDifference')" readonly
                                outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_merus"
                                :label="$t('relConciliation.fields.validMerusTrips')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_invalidas"
                                :label="$t('relConciliation.fields.invalidMerus')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_canceladas"
                                :label="$t('relConciliation.fields.cancelled')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_nao_autorizadas_merus"
                                :label="$t('relConciliation.fields.unauthorizedMerus')" readonly
                                outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_operadora"
                                :label="$t('relConciliation.fields.validOperatorTrips')" readonly
                                outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_invalidas_operadora"
                                :label="$t('relConciliation.fields.invalidOperator')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_nao_realizadas_operadora"
                                :label="$t('relConciliation.fields.notRealized')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_nao_autorizadas_operadora"
                                :label="$t('relConciliation.fields.unauthorizedOperator')" readonly
                                outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_validas_merus_operadora"
                                :label="$t('relConciliation.fields.validMerusOperator')" readonly
                                outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_conciliadas"
                                :label="$t('relConciliation.fields.conciliated')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_nao_conciliadas_merus"
                                :label="$t('relConciliation.fields.notConciliatedMerus')" readonly
                                outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-text-field :value="agregado.n_viagens_nao_conciliadas_operadora"
                                :label="$t('relConciliation.fields.notConciliatedOperator')" readonly
                                outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="agregado.dias_processados_merus"
                                :label="$t('relConciliation.fields.processedDaysMerus')" readonly
                                outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="agregado.n_veiculos_merus"
                                :label="$t('relConciliation.fields.merusVehicles')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="agregado.n_veiculos_merus_autorizados"
                                :label="$t('relConciliation.fields.authorizedMerusVehicles')" readonly
                                outlined></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="agregado.dias_processados_operadora"
                                :label="$t('relConciliation.fields.processedDaysOperator')" readonly
                                outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="agregado.n_veiculos_operadora"
                                :label="$t('relConciliation.fields.operatorVehicles')" readonly outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <v-text-field :value="agregado.n_veiculos_merus_autorizados"
                                :label="$t('relConciliation.fields.authorizedOperatorVehicles')" readonly
                                outlined></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <!-- Nova seção: totais do mesmo período/empresa do agregado geral, quebrados por linha (rota). -->
        <merus-data-table :headers="headersAgregadoPorLinha" :items="agregadoPorLinha" :loading="loadingAgregadoPorLinha"
            :default-multi-sort="defaultMultiSortAgregadoPorLinha" :loading-text="$t('relConciliation.loadingAggregatedByLine')"
            @update:displayedItems="displayedItemsForExportAgregadoLinha = $event"

 cod-tabela="RELCONCILIACAO__AGREGADO_POR_LINHA" @update:headers="headersAgregadoPorLinha = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('relConciliation.aggregatedByLine')" :token="token"
                    :items="displayedItemsForExportAgregadoLinha !== null ? displayedItemsForExportAgregadoLinha : agregadoPorLinha"
                    csv-title="relconciliacaoagregadoporlinha" :pdf-title="$t('relConciliation.aggregatedByLineTitle')"
                    :pdf-headers="headersAgregadoPorLinha" pdf-filename="relconciliacaoagregadoporlinha"
                    :csv-headers="headersAgregadoPorLinha" csv-filename="relconciliacaoagregadoporlinha" hide-search>
                </CadastroToolbar>
            </template>

            <template v-slot:item.n_viagens_merus="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.n_viagens_merus) }}</span>
            </template>

            <template v-slot:item.n_viagens_operadora="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.n_viagens_operadora) }}</span>
            </template>

            <template v-slot:item.km_merus="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.km_merus) }}</span>
            </template>

            <template v-slot:item.km_operadora="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.km_operadora) }}</span>
            </template>

            <template v-slot:item.diff_km_merus_operadora="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.diff_km_merus_operadora) }}</span>
            </template>
        </merus-data-table>

        <merus-data-table :headers="headersMotivos" :items="motivos" :loading="loadingMotivos"
            :default-multi-sort="defaultMultiSortMotivos" :loading-text="$t('relConciliation.loadingMotivos')"
            @update:displayedItems="displayedItemsForExportMotivos = $event"

 cod-tabela="RELCONCILIACAO__MOTIVOS" @update:headers="headersMotivos = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('relConciliation.motivosTitle')" :token="token" :items="displayedItemsForExportMotivos !== null ? displayedItemsForExportMotivos : motivos"
                    csv-title="relconciliacaomotivos" :pdf-title="$t('relConciliation.motivosTitle')"
                    :pdf-headers="headersMotivos" pdf-filename="relconciliacaomotivos" :csv-headers="headersMotivos"
                    csv-filename="relconciliacaomotivos" hide-search>
                </CadastroToolbar>
            </template>
        </merus-data-table>

        <merus-data-table :headers="headersAnalitico" :items="analitico" :loading="loadingAnalitico"
            :default-multi-sort="defaultMultiSortAnalitico" :loading-text="$t('relConciliation.loadingAnalytical')"
            @update:displayedItems="displayedItemsForExportAnalitico = $event"

 cod-tabela="RELCONCILIACAO__ANALITICO" @update:headers="headersAnalitico = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('relConciliation.dailyReportTitle')" :token="token" :items="displayedItemsForExportAnalitico !== null ? displayedItemsForExportAnalitico : analitico"
                    csv-title="relconciliacaoanalitico" :pdf-title="$t('relConciliation.dailyReportTitle')"
                    :pdf-headers="headersAnalitico" pdf-filename="relconciliacaoanalitico"
                    :csv-headers="headersAnalitico" csv-filename="relconciliacaoanalitico" hide-search>
                </CadastroToolbar>
            </template>

            <template v-slot:item.km_merus="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.km_merus) }}</span>
            </template>

            <template v-slot:item.km_operadora="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.km_operadora) }}</span>
            </template>

            <template v-slot:item.diff_merus_operadora_km="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.diff_merus_operadora_km) }}</span>
            </template>

            <template v-slot:item.km_merus_nao_autorizado="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.km_merus_nao_autorizado) }}</span>
            </template>

            <template v-slot:item.km_operadora_nao_autorizado="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.km_operadora_nao_autorizado) }}</span>
            </template>

            <template v-slot:item.km_autorizado_merus="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.km_autorizado_merus) }}</span>
            </template>

            <template v-slot:item.km_autorizado_operadora="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.km_autorizado_operadora) }}</span>
            </template>

            <template v-slot:item.viagens_merus_autorizadas="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.viagens_merus_autorizadas) }}</span>
            </template>

            <template v-slot:item.viagens_operadora_autorizadas="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.viagens_operadora_autorizadas) }}</span>
            </template>
        </merus-data-table>

        <merus-data-table :headers="headers" :items="viagensFiltradas" :loading="loading"
            :default-multi-sort="defaultMultiSort" :item-class="getViagemStyle"
            :loading-text="$t('tripOperation.loadingTrips')"
            @update:displayedItems="displayedItemsForExportViagens = $event"

 cod-tabela="RELCONCILIACAO" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('conciliation.reportTitle')" :token="token" :items="displayedItemsForExportViagens !== null ? displayedItemsForExportViagens : viagensFiltradas"
                    csv-title="relconciliacao" :pdf-title="$t('conciliation.reportTitle')" :pdf-headers="headers"
                    pdf-filename="relconciliacao" :csv-headers="headers" csv-filename="relconciliacao" hide-search>
                    <template v-slot:extension>
                        <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" v-bind="attrs" v-on="on" fab small class="mr-2 mb-2">
                                    <v-icon dark>mdi-filter</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <strong>{{ $t('conciliation.filterTrips') }}</strong>
                                </v-card-title>
                                <v-card-text>
                                    <v-radio-group v-model="filtroViagem" column>
                                        <v-radio :label="$t('conciliation.all')" value="todas"></v-radio>
                                        <v-radio :label="$t('conciliation.conciliated')" value="conciliadas"></v-radio>
                                        <v-radio :label="$t('conciliation.notConciliated')"
                                            value="sem_conciliacao"></v-radio>
                                        <v-radio :label="$t('relConciliation.divergentKm')" value="alerta_km"></v-radio>
                                    </v-radio-group>
                                </v-card-text>
                            </v-card>
                        </v-menu>
                    </template>
                </CadastroToolbar>
            </template>

            <template v-slot:item.km_aferido="{ item }">
                <span>{{ item.km_aferido ? Intl.NumberFormat('pt-BR').format(item.km_aferido) : '' }}</span>
            </template>

            <template v-slot:item.km_nominal="{ item }">
                <span>{{ Intl.NumberFormat('pt-BR').format(item.km_nominal) }}</span>
            </template>

            <template v-slot:item.km_aferido_operadora="{ item }">
                <span>{{ item.km_aferido_operadora ? Intl.NumberFormat('pt-BR').format(item.km_aferido_operadora) : ''
                }}</span>
            </template>
        </merus-data-table>
    </v-container>
</template>
<script>

import EventBus from '@/utils/eventBus';
import apiController from '@/utils/apiController';
import DateUtils from '../utils/dateutils';
import MerusDataTable from './Tables/MerusDataTable.vue';
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import ExportTablePdf from './ExportTablePdf.vue';
import VueJsonToCsv from 'vue-json-to-csv';

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
        ExportTablePdf,
        VueJsonToCsv
    },
    data: () => ({
    headers: [],
    headersAnalitico: [],
    headersMotivos: [],
    headersAgregadoPorLinha: [],
        user: null,
        token: null,
        empresas: [],
        idEmpresaSelected: null,
        dti: null,
        dtf: null,
        timeProps: {
            useSeconds: true,
        },
        config: null,
        formValidado: false,
        viagens: [],
        loading: false,
        motivos: [],
        displayedItemsForExportMotivos: null,
        loadingMotivos: false,
        agregado: {
            n_viagens_merus: 0,
            n_viagens_operadora: 0,
            n_viagens_conciliadas: 0,
            n_viagens_canceladas: 0,
            km_merus: 0,
            km_operadora: 0,
            dias_processados_merus: 0,
            dias_processados_operadora: 0,
            n_veiculos_merus: 0,
            n_veiculos_merus_autorizados: 0,
            n_veiculos_operadora: 0,
            km_merus_nao_autorizado: 0,
            n_viagens_invalidas: 0,
            n_viagens_nao_autorizadas_merus: 0,
            n_viagens_nao_conciliadas_operadora: 0,
            n_viagens_nao_conciliadas_merus: 0,
            n_viagens_nao_realizadas_operadora: 0,
            n_viagens_invalidas_operadora: 0,
            n_viagens_nao_autorizadas_operadora: 0,
            n_viagens_validas_merus_operadora: 0,
            n_veiculos_operadora_autorizados: 0,
            km_operadora_nao_autorizado: 0,
            diff_km_merus_operadora_nao_autorizado: 0,
            diff_km_merus_operadora: 0,
            km_merus_autorizado: 0,
            km_operadora_autorizado: 0,
            diff_km_merus_operadora_autorizado: 0,
        },
        loadingAgregado: false,
        // Uma linha por rota: mesmos filtros dti/dtf e empresa; preenchido pela API getagregadoconciliacaoporlinha.
        agregadoPorLinha: [],
        displayedItemsForExportAgregadoLinha: null,
        loadingAgregadoPorLinha: false,
        analitico: [],
        displayedItemsForExportAnalitico: null,
        loadingAnalitico: false,
        displayedItemsForExportViagens: null,
    }),
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    computed: {
        defaultMultiSort() {
            return [
                { value: 'fonte', options: { text: this.$t('system.labels.increasing'), value: 1 } },
                { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } },
                { value: 'horario_saida_realizada_extenso', options: { text: this.$t('system.labels.increasing'), value: 1 } }]
        },
        defaultMultiSortMotivos() {
            return [
                { value: 'descricao_motivo', options: { text: this.$t('system.labels.increasing'), value: 1 } }]
        },
        defaultMultiSortAnalitico() {
            return [
                { value: 'dt_referencia', options: { text: this.$t('system.labels.increasing'), value: 1 } }]
        },
        // Ordenação inicial da tabela por linha: código da rota.
        defaultMultiSortAgregadoPorLinha() {
            return [
                { value: 'cod_linha', options: { text: this.$t('system.labels.increasing'), value: 1 } }]
        },
    headersAgregado() {
            return [
                { text: this.$t('relConciliation.fields.totalKmMerus'), value: "km_merus", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.unauthorizedKmMerus'), value: "km_merus_nao_autorizado", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.authorizedKmMerus'), value: "km_merus_autorizado", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.totalKmOperator'), value: "km_operadora", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.unauthorizedKmOperator'), value: "km_operadora_nao_autorizado", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.authorizedKmOperator'), value: "km_operadora_autorizado", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.kmDifference'), value: "diff_km_merus_operadora", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.unauthorizedKmDifference'), value: "diff_km_merus_operadora_nao_autorizado", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.authorizedKmDifference'), value: "diff_km_merus_operadora_autorizado", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.validMerusTrips'), value: "n_viagens_merus", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.invalidMerus'), value: "n_viagens_invalidas", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.cancelled'), value: "n_viagens_canceladas", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.unauthorizedMerus'), value: "n_viagens_nao_autorizadas_merus", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.validOperatorTrips'), value: "n_viagens_operadora", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.invalidOperator'), value: "n_viagens_invalidas_operadora", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.notRealized'), value: "n_viagens_nao_realizadas_operadora", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.unauthorizedOperator'), value: "n_viagens_nao_autorizadas_operadora", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.validMerusOperator'), value: "n_viagens_validas_merus_operadora", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.conciliated'), value: "n_viagens_conciliadas", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.notConciliatedMerus'), value: "n_viagens_nao_conciliadas_merus", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.notConciliatedOperator'), value: "n_viagens_nao_conciliadas_operadora", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.processedDaysMerus'), value: "dias_processados_merus", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.merusVehicles'), value: "n_veiculos_merus", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.authorizedMerusVehicles'), value: "n_veiculos_merus_autorizados", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.processedDaysOperator'), value: "dias_processados_operadora", sortable: true, filtrable: true },
                { text: this.$t('relConciliation.fields.operatorVehicles'), value: "n_veiculos_operadora", sortable: true, filtrable: true }]
        },
    filtroViagem() { return this.$t('operation.all') },
        viagensFiltradas() {
            if (this.filtroViagem == "conciliadas") {
                return this.viagens.filter((v) => v.sem_conciliacao == 0);
            } else if (this.filtroViagem == "sem_conciliacao") {
                return this.viagens.filter((v) => v.sem_conciliacao == 1);
            } else if (this.filtroViagem == "alerta_km") {
                return this.viagens.filter((v) => v.alerta_km == 1);
            }

            return this.viagens;
        },
        razaoSocial() {
            return this.empresas.find((e) => e.id_empresa == this.idEmpresaSelected)?.razao_social;
        },
        dataPdfInicial() {
            return this.dti ? this.dti.toLocaleString() : null;
        },
        dataPdfFinal() {
            return this.dtf ? this.dtf.toLocaleString() : null;
        },
        erro() {
            return {
                tipo: this.$t('nav.configurations.system'),
                mensagem: this.$t('system.unknownSystemError'),
                status: null
            };
        },
        textFieldProps() {
            return {
                prependInnerIcon: "mdi-calendar",
                rules: [(v) => !!v || this.$t('contract.messages.selectDate')],
            };
        },
    },
    methods: {

        async initialize() {
            this.config = await this.getConfig();
            this.empresas = await this.populaEmpresas();
        },
        async getConfig() {
            const response = await apiController.request(apiController.endpoints.getallConfig, { silent: true })

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }


            [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(response.data[0].hora_inicial_dia_operacao);
            return response.data[0];
        },
        async populaEmpresas() {
            const response = await apiController.request(apiController.endpoints.getallEmpresas, { silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            return response.data;
        },
        async populaViagens() {
            this.loading = true;
            const payload = {
                idempresa: this.idEmpresaSelected,
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf)
            }

            const response = await apiController.request(apiController.endpoints.getRelatorioconciliacao, { data: payload, silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            this.loading = false;
            this.viagens = response.data;
        },
        async populaAgregado() {
            const payload = {
                idempresa: this.idEmpresaSelected,
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf)
            }

            const response = await apiController.request(apiController.endpoints.getAgregadoconciliacao, { data: payload, silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            this.loadingAgregado = false;
            this.agregado = response.data[0];
        },
        /**
         * Busca o agregado por linha: mesmos parâmetros do agregado geral (empresa + intervalo de datas).
         * A API devolve uma lista; cada item é uma linha com totais Merus x Operadora.
         */
        async populaAgregadoPorLinha() {
            const payload = {
                idempresa: this.idEmpresaSelected,
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf)
            }

            this.loadingAgregadoPorLinha = true;
            const response = await apiController.request(apiController.endpoints.getAgregadoconciliacaoporlinha, { data: payload, silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                this.loadingAgregadoPorLinha = false;
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                this.loadingAgregadoPorLinha = false;
                return [];
            }

            this.loadingAgregadoPorLinha = false;
            this.agregadoPorLinha = response.data;
        },
        async populaAnalitico() {
            const payload = {
                idempresa: this.idEmpresaSelected,
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf)
            }

            this.loadingAnalitico = true;
            const response = await apiController.request(apiController.endpoints.getRelatorioconciliacaoanalitico, { data: payload, silent: true });

            if (response.status !== 200) {
                EventBus.$emit('show-error', { error: { response, status: response.status } });
                return [];
            }

            if (response.data.error) {
                EventBus.$emit('show-error', { error: { response: response.data, status: response.status } });
                return [];
            }

            this.loadingAnalitico = false;
            this.analitico = response.data;
        },
        async populaMotivos() {
            const payload = {
                dti: DateUtils.getDateSQLFormatted(this.dti),
                dtf: DateUtils.getDateSQLFormatted(this.dtf)
            }
            this.loadingMotivos = true;
            const response = await apiController.request(apiController.endpoints.getAgregadoviagensmotivos, { data: payload, silent: true });

            if (response.status !== 200) {
                this.erro.tipo = this.$t('nav.configurations.system');
                this.erro.mensagem = response;
                this.erro.status = response.status;
                this.$refs.erroSistema.showError();
                this.loadingMotivos = false;
                return [];
            }

            if (response.data.error) {
                this.erro.tipo = this.$t('vehicleAuthorization.request');
                this.erro.mensagem = response.data.mensagem;
                this.erro.status = response.status;
                this.$refs.erroSistema.showError();
                this.loadingMotivos = false;
                return [];
            }

            this.loadingMotivos = false;
            this.motivos = response.data;
        },
        async populaRelatorio() {
            this.loadingAgregado = true;
            this.viagens = [];
            this.agregado = [];
            this.agregadoPorLinha = [];
            this.analitico = [];
            if (this.$refs.form.validate()) {
                this.populaViagens();
                this.populaAgregado();
                this.populaAgregadoPorLinha();
                this.populaAnalitico();
                this.populaMotivos();
            }
        },
        getViagemStyle() {
            return "";
        }
    }
}
</script>
<style></style>